<dialog class="gallery-slider" [ngClass]="{'loaded': isLoaded}" #mainEl>

  <div class="gallery-slider__close-button" (click)="onClosed.emit(true)">
    <brt-icon [icon]="'x-thin'"></brt-icon>
  </div>

  <div class="gallery-slider__pagination">
    {{currentSlide}} / {{totalSlides}}
  </div>

  <div class="gallery-slider__nav gallery-slider__nav--prev" (click)="prevSlide()"><brt-icon [icon]="'reg-arrow-left'"></brt-icon></div>
  <div class="gallery-slider__nav gallery-slider__nav--next" (click)="nextSlide()"><brt-icon [icon]="'reg-arrow-right'"></brt-icon></div>

  <div class="gallery-slider__slider-wrapper">

    <swiper [config]="sliderOptions" (init)="saveInstance($event)">
      <ng-template swiperSlide *ngFor="let item of items; index as idx">
        <div class="gallery-slider__slider-item" (click)="goToSlide(idx)">
          <brt-gallery-item [item]="item" (loaded)="onItemLoaded()" [object-fit]="'cover'"></brt-gallery-item>
        </div>
      </ng-template>
    </swiper>
  </div>

  <div class="gallery-slider__captions">
    <ng-container *ngFor="let item of items; index as idx">
      <div class="gallery-slider__caption" [ngClass]="{'visible': idx === currentSlide - 1}"  *ngIf="item.type === 'image'">{{item.image?.info?.caption}}</div>
    </ng-container>
  </div>

</dialog>
